exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-container .header .logo img[data-v-45515884]{width:40px;float:left;margin:5px 10px 10px}.home-container .header .logo h6[data-v-45515884]{margin:10px;text-align:center}", ""]);

// exports
